import React from 'react';
import { cn } from '@/lib/utils';

interface LogoProps {
  /** full = full logo (opaque), fullTransparent = full logo on transparent BG, icon = compact (sidebar), iconTransparent = same logo on transparent (app sidebar). All use marketing-assets logo. */
  variant?: 'full' | 'fullTransparent' | 'icon' | 'iconTransparent';
  /** Size class (e.g., 'h-8', 'h-16') */
  size?: string;
  /** Additional className */
  className?: string;
  /** Override image URL (for white-label brand logos on pages without BrandContext). */
  overrideUrl?: string | null;
  /** Override alt text (for white-label brand logos). */
  overrideAlt?: string | null;
}

/** Full logo (battery icon + WATT TOWER text, transparent background). */
const LOGO_SRC = '/watt-tower-logo-transparent.png';
/** Icon-only logo (battery icon, for compact spaces like favicon/social). */
const ICON_SRC = '/watt-tower-icon-transparent.png';

export function Logo({ variant = 'full', size = 'h-8', className, overrideUrl, overrideAlt }: LogoProps): JSX.Element {
  const isIconVariant = variant === 'icon' || variant === 'iconTransparent';
  const src = overrideUrl || (isIconVariant ? ICON_SRC : LOGO_SRC);
  return (
    <img
      src={src}
      alt={overrideAlt || 'Watt Tower — Solar fleet monitoring for installers'}
      className={cn('h-auto w-auto object-contain', size, className)}
    />
  );
}
